module.exports = fox._r("images/promo/contest/Day1140x400.png", __webpack_public_path__ + "_/common/images/promo/contest/Day1140x400.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/contest/Day1140x400.png
// module id = 423
// module chunks = 2